/**
 * User-Agent를 기반으로 모바일/태블릿 디바이스를 감지하는 함수입니다.
 *
 * 화면 크기에 의존하는 방식은 데스크톱 브라우저의 창 크기를 줄였을 때도
 * 모바일로 잘못 판단하는 문제가 있어 안정적이지 않습니다.
 *
 * 대신, 브라우저가 제공하는 고유 식별자인 User-Agent를 확인하는 것이
 * 업계에서 보편적으로 사용되는 방법입니다. 이 방법은 기기의 종류(모바일/데스크톱)를
 * 직접적으로 판별하므로, 라우팅 분기와 같이 명확한 구분이 필요할 때 더 적합합니다.
 *
 * @returns {boolean} 모바일/태블릿이면 true, 데스크톱이면 false
 */
export function isMobile() {
  // 서버 사이드 렌더링(SSR) 환경과 같이 navigator 객체가 없는 경우를 대비합니다.
  if (typeof navigator === 'undefined') {
    return false;
  }
  
  const userAgent = navigator.userAgent;

  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return mobilePatterns.some((pattern) => pattern.test(userAgent));
}